
export class Valve {
    id: string;
    mdSceValveTypeId: string;
    oem: string;
    model: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    partNo: string;
    installedDate?: string;
    isActuated: boolean;
    // type?: string; // isActuated, true = 'pneumatic' , false = 'manual'
    equipmentBrand: string;
    actuatorModel: string;
    actuatorType: string;
    openingCm: number;
    closingCm: number;
    openingSec: number;
    closingSec: number;
    fullyClose: number;
    fullyOpen: number;
    jammed: number;
    allowLeakRatePsi10mins: number;
    status: string;
    remark: string;
    sceXmasTreeId: string;
    hydraulicReturn: number;
    createdAt: string;

    constructor(initialValues: Partial<Valve> = {}) {
        Object.assign(this, initialValues);
    }

     reset() {
        const initialValues: Partial<Valve> = {
            id: '',
            mdSceValveTypeId: '',
            oem: '',
            model: '',
            sizeIn: 0,
            ratingPsi: 0,
            manufacturer: '',
            partNo: '',
            installedDate: '',
            isActuated: true,
            // type: '',
            equipmentBrand: '',
            actuatorModel: '',
            actuatorType: 'Pneumatic',
            openingCm: null,
            closingCm: null,
            openingSec: null,
            closingSec: null,
            fullyClose: null,
            fullyOpen: null,
            jammed: null,
            allowLeakRatePsi10mins: 0,
            status: '',
            remark: '',
            sceXmasTreeId: '',
            hydraulicReturn: null,
            createdAt: '',
        };
        Object.assign(this, initialValues);
    }
}